import React from 'react';
import { Info } from 'lucide-react';

interface InfoBoxProps {
  requirements: {
    required: string;
    optional: string;
    additional?: string;
  };
}

const InfoBox: React.FC<InfoBoxProps> = ({ requirements }) => {
  return (
    <div className="s-admin-bulk-upload-info-box">
      <Info size={20} className="s-admin-bulk-upload-info-icon" />
      <div className="s-admin-bulk-upload-info-content">
        <h3 className="s-admin-bulk-upload-info-title">CSV Requirements</h3>
        <ul className="s-admin-bulk-upload-info-list">
          <li><strong>Required fields:</strong> {requirements.required}</li>
          <li><strong>Optional fields:</strong> {requirements.optional}</li>
          <li><strong>{requirements.additional}</strong></li>
        </ul>
      </div>
    </div>
  );
};

export default InfoBox;
